import axios from "axios";
import { post, del, get, put } from "./api_helper";
import { transakGet } from "./transak_api_helper";

import * as url from "./url_helper";
import authTokenHeader from "./jwt-token-access/auth-token-header";

// Login Method
export const postLogin = (data) => post(url.POST_LOGIN, data,);
export const postLoginWithOtp = (data) => post(url.POST_LOGIN_OTP, data);
export const getCurrentUser = (data) => post(url.POST_LOGIN, data);
export const postChangePassword = (data) => post(url.POST_CHANGE_PASSWORD, data);
export const postEditProfile = (data) => post(url.POST_EDIT_PROFILE, data);
export const postSetPassword = (data) => post(url.POST_SET_PASSWORD, data);

export const socialLoginAPI = (data) => post(url.POST_SOCIAL_LOGIN, data);

export const postVerifyEmail = (data) => post(url.POST_VERIFY_EMAIL, data);

export const postResetPassword = (data) => post(url.POST_RESET_PASSWORD, data);

//Send OTP
export const postsendOtp = (data) => post(url.POST_SEND_OTP, data);
export const postVerifyOtp = (data) => post(url.POST_VERIFY_OTP, data);

// Register
export const postRegister = (data) => post(url.POST_REGISTER, data);

// Profile
export const putProfile = (data) => post(url.PUT_PROFILE, data);
export const putChangePassword = (data) => post(url.CHANGE_PASSWORD, data);

export const postForgetPwd = (data) => post(url.FORGET_PASSWORD, data);
export const postResetPwd = (data) => put(url.CHANGE_PASSWORD, data);

//all pairs
export const getAllPairsListApi = (data) => post(url.GET_ALL_PAIRS_LIST, data);

// File
export const postFile = (data) => {


    const formData = new FormData()

    Object.entries(data).map(([key, value]) => formData.append(key, value))

    const config = {
        headers: { ...authTokenHeader(), "content-type": "multipart/form-data" },
    }

    return post(url.POST_FILE, formData, config)
}

export const postUploadProfileImg = (data) => post(url.POST_UPLOAD_PROFILE_IMG, data)

export const postDeleteProfileImg = (data) => post(url.POST_DELETE_PROFILE_IMG, data)


export const postRemoveFile = (data) => post(url.POST_REMOVE_FILE, data)
// Settings
export const getSettingsApi = (data) => get(url.GET_SETTINGS, data);

//transactions 
export const getTransactionsApi = (data) => post(url.GET_TRANSACTIONS, data);
export const addTransactionApi = (data) => post(url.ADD_TRANSACTION, data);

export const getTopTradePairsApi = (data) => post(url.GET_TOP_TRADE_PAIRS, data);


//Home
export const postJoinUs = (data) => post(url.POST_JOIN_US, data);


//Currency 
export const getCurrencyApi = (data) => post(url.GET_CURRENCY, data);
export const getCryptoApi = (data) => post(url.GET_CRYPTO, data);

// Faqs
export const getFaqsApi = (data) => post(url.GET_FAQS, data);


//Get Kyc
export const postKycDetail = (data) => post(url.POST_GET_KYC_DETAIL, data);
export const postKycStatus = (data) => post(url.POST_GET_KYC_STATUS, data);

export const postUserProfile = (data) => post(url.POST_GET_USER_PROFILE, data);

// Wallet


export const assetWithdrawAPI = (data) => post(url.POST_ASSET_WITHDRAW, data);

export const assetWithdrawHistory = (data) => post(url.ASSET_WITHDRAW_HISTORY, data);

export const getContentApi = (data) => get(url.GET_CONTENT + data?.data);

export const apiTransactionHistory = (data) => post(url.TRANSACTION_HISTORY, data);

// UniRamp

export const getQuoteListApi = (data) => post(url.GET_UNIRAMP_QUOTE_LIST, data);

export const createTransactionApi = (data) => post(url.CREATE_UNIRAMP_TRANSACTION, data);


// Blogs
export const getBlogsApi = (data) => post(url.GET_BLOGS, data);
export const getBlogSlugApi = (data) => get(url.GET_BLOGS_BY_SLUG + data?.data);

// Favourite
export const addFavApi = (data) => post(url.ADD_FAV, data);
export const getFavApi = (data) => post(url.GET_FAV, data);
